import styled from 'styled-components';

// 디폴트 테이블
export const Table = styled.table`
  width: 100%;
  border-collapse: separate;
  border-spacing: 0;
  box-sizing: border-box;

  td, th {
    padding: 10px;
    box-sizing: border-box;
  }

  thead {
    background-color: #373940;
    
    tr {
      th {
        height: 50px;
        color: #fff;
        font-size: 13px;
        font-weight: 400;
      }
    }
  }

  tbody {
    tr {
      td, th {
        font-size: 13px;
        line-height: 20px;
        word-break: break-all;
        border-bottom: 1px solid #90A4AE;
        border-left: 1px solid #90A4AE;
        position: relative;

        &:last-child {
          border-right: 1px solid #90A4AE;
        }
      }

      &:last-child {
        td:first-child,
        th:first-child {
          border-bottom-left-radius: 6px;
        }
        td:last-child {
          border-top: 0;
          border-bottom-right-radius: 6px;
        }
      }
        
      &:nth-child(even) {
        background-color: #eaecef;
      }
    }
  }
`


export const TableWithTbody = styled.table`
  width: 100%;
  border-collapse: separate;
  border-spacing: 0;
  box-sizing: border-box;

  td, th {
    padding: 5px;
  }

  thead {
    background-color: #373940;
    
    tr {
      border-bottom: 1px solid #43454e;

      th {
        height: 50px;
        color: #fff;
        font-size: 13px;
        font-weight: 400;
        border-left: 1px solid #43454e;
        border-bottom: 1px solid #43454e;

        > p {
          color: inherit;
          font-size: inherit;
          font-weight: inherit;
        }
      }
      
      & + tr {
        border-top: 1px solid #43454e;
      }

      &:nth-child(2) {
        th:first-child {
          border-left: 0;
        }
      }
    }
  }

  tbody {
    tr {
      td {
        font-size: 12px;
        word-break: break-all;
        border-bottom: 1px solid #90A4AE;
        border-left: 1px solid #90A4AE;

        > p {
          font-size: inherit;
        }
      }

      &:first-child {
        td:last-child {
          border-right: 1px solid #90A4AE;
        }
      }
    }

    // &:last-child {
    //   tr:first-child {
    //     td:first-child {
    //       border-bottom-left-radius: 10px;
    //     }
    //     td:last-child {
    //       border-bottom-right-radius: 10px;
    //     }
    //   }
    // }

    &:nth-child(even) {
      background-color: #eaecef;
    }
  
    ul {
      margin-top: 5px;
      padding-left: 20px;
    }
  }
`


export const Th = styled.th`
  height: 50px;
  width: 50%;
  padding: 0 !important;
  padding-left: 10px !important;
  font-size: 17px !important;
  text-align: left;
  font-weight: 700 !important;
  border: 1px solid #90A4AE;
  border-bottom: 0;
  background-color: ${props => props.isActive ? `#373940` : `#FFF`};
  color: ${props => props.isActive ? `#FFF` : `#373940`} !important;
  text-align: center;
  border-right: 0;
  cursor: pointer;
  
  & + th {
    border-right: 1px solid #90A4AE;
    border-left: 0;
  }

  &:hover {
    color: #FFF !important;
    background-color: #373940;
  }
`


// WEBPACK FOOTER //
// ./client/components/Styled/Table/index.js